import FormItemlist from "./form-itemlist";
import * as React from "react";
import ReactDOM from "react-dom";

export default class Form {
    constructor(element) {
        this.element = element;
        this.form = this.element.querySelector("form");
        this.endpoint = this.form.getAttribute("action");

        this.form.addEventListener("submit", (event) => {
            event.preventDefault();
            event.stopPropagation();

            this.submit();

            return false;
        });

        this.form.querySelector("button[type='submit']").addEventListener("click", () => {
            this.form.classList.add("show-validation");
        });

        this.feedbackDisplay = document.createElement("div");
        this.feedbackDisplay.classList.add("feedback");
        this.form.appendChild(this.feedbackDisplay);
        this.resetGlobalFeedback();

        this.phrases = {
            success: this.form.getAttribute("data-success") || "Anfrage versendet.",
            error: this.form.getAttribute("data-error") || "Es ist ein Fehler aufgetreten."
        };

        this.initializeItemLists();
    }

    initializeItemLists() {
        let itemlists = this.form.querySelectorAll(".itemlist");

        for (let i = 0; i < itemlists.length; i++) {
            this.initializeItemlist(itemlists[i]);
        }
    }

    initializeItemlist(element) {
        let formData = JSON.parse(element.querySelector("script").innerText);
        let container = element.querySelector(".react-container");
        let formField = element.querySelector(".itemlist__result");

        ReactDOM.render(<FormItemlist formData={formData} onUpdate={(textResult) => {
            formField.value = textResult
        }}/>, container);
    }

    submit() {
        let data = this.getFormData();

        /* Disable button after submit to prevent double sent forms */
        this.blockSubmit(data)

        this.setLoading(true);
        this.resetGlobalFeedback();

        fetch(this.endpoint, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        })
            .then(response => response.json())
            .then(data => {
                this.setLoading(false);

                if (typeof data.success !== "boolean" || !data.success) {
                    return this.showGlobalFeedback(this.phrases.error, true);
                }

                this.showGlobalFeedback(this.phrases.success);
            });

        return false;
    }

    setLoading(status) {
        if (!status) {
            return this.form.classList.remove("loading");
        }

        this.form.classList.add("loading");
    }

    resetGlobalFeedback() {
        this.showGlobalFeedback(null);
    }

    showGlobalFeedback(message, isError = false) {
        if (!message) {
            this.feedbackDisplay.removeAttribute("role");
            this.feedbackDisplay.setAttribute("aria-expanded", "false");
            return this.feedbackDisplay.innerText = "";
        }

        if (isError) {
            this.feedbackDisplay.setAttribute("role", "alert");
        }

        this.feedbackDisplay.setAttribute("aria-expanded", "true");
        this.feedbackDisplay.innerText = message;
    }

    getFormData() {
        let formData = new FormData(this.form);

        let mailSetting = this.form.querySelector("#mail_setting_name").value;
        let sourceDocument = this.form.querySelector("#document_id").value;
        let formName = this.form.getAttribute("data-formname");

        let result = {
            info: {mailSetting: mailSetting, document: sourceDocument, name: formName, confirmationMails: []},
            fields: []
        };

        for (var pair of formData.entries()) {
            let field = {name: pair[0], value: pair[1]};

            let domElement = document.getElementById(pair[0]);

            if (domElement !== null && domElement.labels !== null && domElement.labels[0]) {
                field.label = domElement.labels[0].innerText;
            }

            if (domElement !== null && domElement.hasAttribute("aria-label")) {
                field.label = domElement.getAttribute("aria-label");
            }

            if (domElement !== null && domElement.hasAttribute("data-isConfirmationEmail")) {

                let isConfirmationEmail = domElement.getAttribute("data-isConfirmationEmail");

                if (isConfirmationEmail === null) {
                    continue;
                }

                if (isConfirmationEmail === "1") {
                    result.info.confirmationMails.push(field.value);
                }
            }

            result.fields.push(field);
        }

        return result;
    }

    blockSubmit(data) {
        let button = this.form.querySelector("button[type='submit']")
        button.disabled = true
        /* Setting endless loop here to detect changes in the form and reactivate the submit button */
        let i = setInterval(() => {
            if (JSON.stringify(data) !== JSON.stringify(this.getFormData())) {
                button.disabled = false
                clearInterval(i)
            }
        }, 1000)
    }
}
